import DocumentIcon from '@heroicons/react/outline/DocumentIcon'
import DownloadIcon from '@heroicons/react/outline/DownloadIcon'
import dayjs from 'dayjs'
import { capitalize } from 'lodash'

import { useInvoices } from '@tribeplatform/react-sdk/hooks'
import { EmptyState } from '@tribeplatform/react-ui-kit/EmptyState'
import { Table } from '@tribeplatform/react-ui-kit/Table'

export const Payments = () => {
  const { data: invoices } = useInvoices()

  if (!invoices?.length) {
    return (
      <div className="my-16">
        <EmptyState
          icon={<DocumentIcon />}
          title="No payments yet"
          description="Nothing here at this time."
        />
      </div>
    )
  }

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Invoice</Table.HeaderCell>
          <Table.HeaderCell>Payment Method</Table.HeaderCell>
          <Table.HeaderCell>Total</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
          <Table.HeaderCell />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {invoices?.map(invoice => (
          <Table.Row key={invoice.invoiceUrl}>
            <Table.Cell>
              {dayjs(invoice?.date).format('MMMM D, YYYY')}
            </Table.Cell>
            <Table.Cell>Ending with {invoice?.cardLastFourDigits}</Table.Cell>
            <Table.Cell>
              {invoice?.total
                ?.toLocaleString('en-US', {
                  style: 'currency',
                  currency: invoice.currency,
                })
                .concat(` ${invoice.currency.toUpperCase()}`)}
            </Table.Cell>
            <Table.Cell>{capitalize(invoice?.status)}</Table.Cell>
            <Table.Cell>
              <a href={invoice?.invoiceUrl} download>
                <DownloadIcon className="h-8 w-8" />
              </a>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  )
}
